import { MedalliaCompanyInfo, MedalliaUserProfile } from "../interfaces/MedalliaCustomParameters.interface";
import CONSTANTS from "./constants";

export function setMedalliaUserProfile(userProfile: MedalliaUserProfile): void {
    try {
        window['userProfile'] = {
            firstName: userProfile.firstName,
            lastName: userProfile.lastName,
            email: userProfile.email,
        };
    } catch (error) {
        console.log(error);
    }
}

export function setMedalliaCompanyInfo(companyInfo: MedalliaCompanyInfo): void {
    try {
        window['companyInfo'] = {
            journeyId: companyInfo.journeyId,
            companyName: companyInfo.companyName,
            productType: companyInfo.journeyId ? CONSTANTS.DLA : CONSTANTS.ADF
        };
    } catch (error) {
      console.log(error);
    }
}